/**
 * @description 會員註冊 step 2 國籍別用
*/
export enum NationalType {
  /** 本國人 */
  National = 'N',
  /** 外國人 */
  Foreigner = 'F',
  /** 法人 */
  Legal = 'L'
}
